import { SagaIterator } from "redux-saga";
import { all, call, fork, put, takeLatest } from "redux-saga/effects";

import {
  deleteLogoError,
  deleteLogoRequest,
  deleteLogoSuccess,
  fetchLogoError,
  fetchLogoRequest,
  fetchLogoSuccess,
  uploadLogoError,
  uploadLogoRequest,
  uploadLogoSuccess,
} from "./actions";
import { DELETE_LOGO, FETCH_LOGO, UPLOAD_LOGO } from "./constants";
import {
  IDeleteLogoAction,
  IFetchLogoAction,
  IUploadLogoAction,
} from "./types";
import businessLogoAPIService from "../../services/api/businessLogo";

export function* fetchLogoSaga({ payload }: IFetchLogoAction): SagaIterator {
  try {
    yield put(fetchLogoRequest());

    const response = yield call(
      [businessLogoAPIService, businessLogoAPIService.getLogo],
      payload,
    );

    yield put(
      fetchLogoSuccess({
        url: response?.url,
      }),
    );
  } catch (error) {
    if (error?.response?.status === 404) {
      yield put(fetchLogoSuccess(undefined));
      return;
    }
    yield put(fetchLogoError(error));
  }
}

export function* uploadLogoSaga({ payload }: IUploadLogoAction): SagaIterator {
  try {
    yield put(uploadLogoRequest());

    const response = yield call(
      [businessLogoAPIService, businessLogoAPIService.uploadLogo],
      payload.customerId,
      payload.file,
    );

    yield put(
      uploadLogoSuccess({
        url: response?.url,
      }),
    );

    if (payload.onSuccess) {
      yield call(payload.onSuccess, response?.url);
    }
  } catch (error) {
    yield put(uploadLogoError(error));

    if (payload.onError) {
      yield call(payload.onError, error);
    }
  }
}

export function* deleteLogoSaga({ payload }: IDeleteLogoAction): SagaIterator {
  try {
    yield put(deleteLogoRequest());

    yield call(
      [businessLogoAPIService, businessLogoAPIService.deleteLogo],
      payload.customerId,
    );

    yield put(deleteLogoSuccess());

    if (payload.onSuccess) {
      yield call(payload.onSuccess);
    }
  } catch (error) {
    yield put(deleteLogoError(error));

    if (payload.onError) {
      yield call(payload.onError, error);
    }
  }
}

export function* watchFetchLogo(): SagaIterator {
  yield takeLatest(FETCH_LOGO, fetchLogoSaga);
}

export function* watchUploadLogo(): SagaIterator {
  yield takeLatest(UPLOAD_LOGO, uploadLogoSaga);
}

export function* watchDeleteLogo(): SagaIterator {
  yield takeLatest(DELETE_LOGO, deleteLogoSaga);
}

export function* businessSettingsSaga(): SagaIterator {
  yield all([
    fork(watchFetchLogo),
    fork(watchUploadLogo),
    fork(watchDeleteLogo),
  ]);
}
